import { Component, EventEmitter, Input, Output } from '@angular/core'
import { AnchorService } from 'dmmp-services'

@Component({
  selector: 'dmmp-menu',
  templateUrl: './menu.component.html',
})
export class MenuComponent {
  @Input() menu: any
  @Output() close =  new EventEmitter()

  constructor(public anchorService: AnchorService) {
  }
}
